import { render, staticRenderFns } from "./ingredients-steps-list-cmp.vue?vue&type=template&id=137abef9&scoped=true"
import script from "./ingredients-steps-list-cmp.vue?vue&type=script&lang=js"
export * from "./ingredients-steps-list-cmp.vue?vue&type=script&lang=js"
import style0 from "./ingredients-steps-list-cmp.vue?vue&type=style&index=0&id=137abef9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137abef9",
  null
  
)

export default component.exports